import { Component, Vue, Watch } from 'vue-property-decorator';
import { RadarRouter } from './router';
import { CommonStates } from './services/CommonStates/common.states';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faBath, faBed, faWarehouse, faPhone, faMapMarkedAlt, faEnvelope, faMapMarkerAlt, faSearch,
    faArrowAltCircleUp, faArrowAltCircleDown, faArrowCircleUp, faArrowCircleDown, faTimes, faUsers, faHome,
    faThumbsUp,
    faCheckCircle,
    faTimesCircle
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Footer from './shared/Footer/footer.vue';
import Header from './shared/Header/header.vue';
import { Models } from './models/models';
import { CommonConfig } from './configs/config.common';
import VueI18n from 'vue-i18n';
import { I18N } from './utils/i18n/i18n';
import * as T_T from 'cryface';
import { UserInfoDelegate } from './services/DataDelegate/UserInfoDelegate/user.info.delegate';
import SpinLoader from './shared/SpinLoader/spin.loader.vue';
import { WechatDelegate } from './services/DataDelegate/WechatDelegate/wechat.delegate';
import { AxiosPromise } from './utils/axios.promise';
import { HimuraInject } from 'himura';
import { BrowserService } from './services/browser.service';
import ClientCLogin from './shared/ClientCLogin/client.c.vue';
import { RifoTamplateStates } from './services/CommonStates/States/template.state';
import EpicSignInCard from '../src/RifoDesign/EpicSignInCard/epic.signin.card.vue';
import EpicHeader from '../src/RifoDesign/EpicHeader/epic.header.vue';
import { rifoWebRoutesFactory } from './routes/rifo.website.routes';
import { CallNative } from './services/EpicContextService/call.native';
import { EpicContextService } from './services/EpicContextService/epic.context';
import { HybridZhCn } from './utils/i18n/hybrid/zh.cn';
import { HybridEn } from './utils/i18n/hybrid/en';
import { ZhCn } from './utils/i18n/zh.cn';
import { En } from './utils/i18n/en';
import { RifoEpicLogger } from './utils/logger';
import { NoticeConfig } from 'iview';
import { MetaMap } from './meta';
// import ApolloClient from 'apollo-boost';
// import { ApolloClient } from 'apollo-client';
// import VueApollo from 'vue-apollo';
// import { createHttpLink } from 'apollo-link-http';
// import { InMemoryCache } from 'apollo-cache-inmemory';

// const cache = new InMemoryCache();
// const httpLink = createHttpLink({
//     // You should use an absolute URL here
//     uri: 'http://uat-api.realjaja.com/graphql-srv/graphql',
// });
// const apolloClient = new ApolloClient({
//     link: httpLink,
//     cache,
// });
// Vue.use(VueApollo);
// const apolloProvider = new VueApollo({
//     defaultClient: apolloClient,
// });

library.add(faBath, faBed, faWarehouse, faPhone, faMapMarkedAlt,
    faEnvelope, faMapMarkerAlt, faSearch, faArrowCircleUp, faArrowCircleDown, faTimes
    , faUsers, faHome, faThumbsUp, faCheckCircle, faTimes, faTimesCircle);

Vue.component('font-awesome-icon', FontAwesomeIcon);

const messages = I18N.factory();
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: 'en', // set locale
    messages, // set locale messages
});

const router = RadarRouter.routerFactory();

const store = CommonStates.factory();

@Component({
    components: {
        Header,
        Footer,
        SpinLoader,
        ClientCLogin,
        EpicSignInCard,
        EpicHeader,
    },
    store,
    router,
    i18n,
    // apolloProvider,
    metaInfo() {
        const routePath = this.$route.path;
        const config = MetaMap.find(configItem => {
            return configItem.reg.test(routePath);
        });
        console.log('config found', config);
        if (!config) {
            return {
                meta: [{ name: 'viewport', content: 'width=device-width, initial-scale=1' }]
            };
        } else {
            if (BrowserService.isWWW()) {
                return {
                    meta: config.rules['WWW']
                };
            } else {
                return {
                    meta: config.rules['notWWW']
                };
            }
        }
    }
})
export default class App extends Vue {

    public configs = new CommonConfig();

    public userInfoService = new UserInfoDelegate();

    public wechat = new WechatDelegate();

    public isLoading = false;

    public backToTopOffset = '2rem';

    public ltype = 0;

    public showFooter() {
        const show = (!this.$store.state.app.isWWW
            && (this.$route.fullPath.indexOf('/hybrid/') === -1) && (this.$route.fullPath !== '/map'))
            || (this.$route.fullPath.indexOf('/hybrid/share/list') > -1);
        return show;
    }

    @Watch('$store.state.app.isFetching', { immediate: true, deep: true })
    public onLoading(val: any, oldVal: any) {
        if (val === 0) {
            this.isLoading = false;
        } else {
            this.isLoading = true;
        }
    }
    public beforeCreate() {
        const himura = HimuraInject.Injector.getInstance();
        // const entryUrl = encodeURIComponent(location.href);
        // alert(`${entryUrl}, origin ${location.href}`);
        himura.addResource('entryUrl', location.href);
    }

    @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
    public async onUserChanged(val: any, oldVal: any) {
        // if (T_T.simpleDetect(val.value.agentName)) {
        //     console.log(`${val.value.agentName}'s Frontstore`);
        //     document.title = `${val.value.agentName}'s Frontstore`;
        // }
        if (T_T.simpleDetect(val.value)) {
            if (T_T.simpleDetect(val.value.website_status)) {
                if (!val.value.website_status) {
                    // this.$router.push('/not/found');
                    // const noticeConfig: NoticeConfig = {
                    //     desc: 'Agent Website Inactive',
                    //     title: 'Error',
                    // };
                    // this.$Notice.warning(noticeConfig);
                }
            }
        }
    }

    public async created() {
        // debug Mode
        RifoEpicLogger.init(this.configs);
        this.$store.commit('updateIsWWW', BrowserService.isWWW());
        // init epicContext
        this.routerGuards();
        this.routerCreated();
        this.routerChange();
        this.getI18nConfig();
        // this.$store.commit('updateIsWWW', true);
        // getUserC
        this.getUserCLocal();
        window.onresize = () => {
            this.$store.commit('updateWindowWidth');
        };
        window.addEventListener('scroll', this.handleScroll);
        this.$store.commit('appStartFetching');
        if (BrowserService.isWWW()) {
            this.$store.commit('setTemplate', RifoTamplateStates.ERifoTemplates.Epic);
        } else {
            await this._authenticate();
        }
        this.$store.commit('appEndFetching');
        if (CallNative.isAndroid() || CallNative.isIos()) {
            try {
                CallNative.runSetEpicContext();
            } catch (e) { }
            // delay to wait native setting complete
            await T_T.delay(300);
        }
    }

    private async _authenticate() {
        let agentUrl = this.$route.query.agentUrl;
        const hostname: any = window.location.hostname;
        if (hostname === 'localhost') {
            agentUrl = 'leisun1.uat.rifo.co';
        } else {
            agentUrl = hostname;
        }
        if (T_T.simpleDetect(agentUrl)) {
            const _store = this.$store;
            const result = await this.userInfoService.getRemoteUser(_store, `${<string>agentUrl}`);
            if (result === 1) {
                const userInfo: Models.RoseGun = this.userInfoService.Data;
                const host = this.configs.cmisapiHost;
                const data: any = await AxiosPromise.get(`${host}/ur/info?userId=${userInfo.cims_uid}&ltype=1&isLoadAvatar=false`);
                // document.title = 'Title';
                // console.log(userInfo);
                this.$store.commit('setStoreInfo', userInfo);
                if (data.code === 200) {
                    this.userInfoService.UserDetail = data.data;
                    data.data.website_status = userInfo.website_status;
                    // console.log(userInfo.website_title);
                    this.$store.commit('setUser', data.data);
                    // console.log(data.data);
                    if (T_T.simpleDetect(userInfo.website_title)) {
                        document.title = BrowserService.isWWW() ? 'RIFO' : userInfo.website_title;
                    } else {
                        document.title = T_T.simpleDetect(this.configs.appTitle) ? this.configs.appTitle : 'RIFO Epic';
                    }
                }
            }
        }
    }

    public handleScroll(event: any) {
        this.$store.commit('onScrollY', window.scrollY);
    }

    public destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    public mounted() {
        this.initI18N();
    }

    @Watch('$store.state.scrollBar.scrollY', { immediate: true, deep: true })
    public onScrollYChanged(val: any, oldVal: any) {
        const bottom = document.documentElement.offsetHeight - (val + window.innerHeight);
        if (bottom <= 50) {
            this.backToTopOffset = '5rem';
        } else {
            this.backToTopOffset = '2rem';
        }
    }

    @Watch('globalPudge.context', { immediate: true, deep: true })
    public onGlobalPudgeChange(val: any, oldVal: any) {
        this.initI18N();
    }
    public initI18N() {
        const language: any = this.globalPudge.functions.getParam(EpicContextService.EEpicContextParams.language);
        this.ltype = language;
        if (BrowserService.isWWW()) {
            const locale = T_T.simpleDetect(language) ? I18N.ltypeToLocale(language!.value) : I18N.EI18nLocale.En;
            this.$i18n.locale = locale;
        } else {
            const ltype = this.$route.query.ltype ?
                parseInt(this.$route.query.ltype as string, 10)
                : 1;
            const locale = I18N.ltypeToLocale(ltype);
            this.$i18n.locale = locale;
        }
    }

    public injectI18NLang(route: any) {
        if (route.query.ltype) {
            const ltype = parseInt(route.query.ltype.toString(), 10);
            if (ltype === 0 || ltype === 1) {
                this.globalPudge.functions.setParam(
                    EpicContextService.EEpicContextParams.language,
                    ltype);
            }
        }
    }
    public routerGuards() {
        this.injectI18NLang(this.$route);
        router.beforeEach((to, from, next) => {
            this.injectI18NLang(to);
            if (to.meta && to.meta.title) {
                document.title = to.meta.title;
            }
            next();
        });
        router.afterEach((to, from) => {
            this.getI18nConfig();
            const path = to.matched[0].path;
            // if (to.matched && to.matched.length) {
            //     this.detectRedirectDownloadPath(path);
            // }
        });
    }

    public detectRedirectDownloadPath(path: string) {
        const rifoRoutes = rifoWebRoutesFactory();
        const routeFound = rifoRoutes.find(val => {
            return val.path === path || val.path === (path + '/');
        });
        if (routeFound
            && window.innerWidth < 768
            && this.$store.state.app.isWWW) {
            this.$router.push('/download-app');
        }
    }
    public routerCreated() {
        if (this.$route.meta && this.$route.meta.title) {
            document.title = this.$route.meta.title;
        }
        const path = this.$route.matched[0].path;
        // if (this.$route.matched && this.$route.matched.length) {
        //     this.detectRedirectDownloadPath(path);
        // }
    }
    public routerChange() { }

    @Watch('$store.state.app.windowWidth', { immediate: true, deep: true })
    public onResize(val: any, oldVal: any) {
        const path = this.$route.matched[0].path;
        // if (this.$route.matched && this.$route.matched.length) {
        //     this.detectRedirectDownloadPath(path);
        // }
    }

    public getBgBlur() {
        if (BrowserService.isWWW()) {
            if (this.$route.path.indexOf('/hybrid') !== -1) {
                return {};
            }
            return this.$store.state.app.bgBlur ? {
                'filter': 'blur(5px)'
            } : {
                    'filter': 'none'
                };
        } else {
            return {};
        }
    }

    public setBlur() {
    }

    public getUserCLocal() {
        const _this: any = this;
        const browserStore: any = _this.$browserStore;
        try {
            const userCInfo = JSON.parse(browserStore.getSession('Swap'));
            if (T_T.simpleDetect(userCInfo)) {
                this.$store.commit('setClientCLogin', userCInfo);
            }
        } catch (e) { }
    }

    public getI18nConfig() {
        console.debug('Configuring I18N');
        if (this.$route.path.indexOf('/hybrid') !== -1) {
            this.$i18n.setLocaleMessage(I18N.EI18nLocale.Zn, HybridZhCn.factory());
            this.$i18n.setLocaleMessage(I18N.EI18nLocale.En, HybridEn.factory());
        } else {
            this.$i18n.setLocaleMessage(I18N.EI18nLocale.Zn, ZhCn.factory());
            this.$i18n.setLocaleMessage(I18N.EI18nLocale.En, En.factory());
        }
    }
}
